module.exports = __webpack_public_path__ + "img/placeholder.5be99253.png";